<div id="application-info" class="container-fluid">
  <div
    class="application-info grid-container"
    style="transform-style: preserve-3d"
  >
    <div class="application-info__nav grid-switch-button p-3">
      <button
        class="btn btn-lg bg-primary text-white mdi mdi-chevron-left"
        [routerLink]="['/dashboard']"
      >
        Terug naar groeimeter
      </button>
    </div>

    <div class="application-info__container row p-3 bg-white">
      <div class="d-none d-lg-block col-lg-3">
        <div
          *ngIf="!showFaq"
          class="application-info__container__table-of-contents px-1 d-flex flex-column align-items-end"
        >
          <h3>Inhoud</h3>
          <ul>
            <li
              *ngFor="let tocItem of getInfoToc()"
              (click)="scrollToTocItem(tocItem.gotoId)"
            >
              {{ tocItem.label }}
            </li>
          </ul>
        </div>
        <div
          *ngIf="showFaq"
          class="application-info__container__table-of-contents px-1 d-flex flex-column align-items-end"
        >
          <h3>Inhoud</h3>
          <ul>
            <li
              *ngFor="let tocItem of getFaqToc()"
              (click)="scrollToTocItem(tocItem.gotoId)"
            >
              {{ tocItem.label }}
            </li>
          </ul>
        </div>
      </div>
      <div class="col-12 col-lg-6">
        <div class="application-info__container__navigation">
          <img src="assets/GroeimeterLogo_2025.gif" />
          <button *ngIf="showFaq" (click)="toggleFaq()" class="btn btn-none">
            Toon uitleg
          </button>
          <button *ngIf="!showFaq" (click)="toggleFaq()" class="btn btn-none">
            Toon veelgestelde vragen
          </button>
        </div>
        <div
          *ngIf="!showFaq"
          style="max-width: 980px"
          class="application-info__container__content mx-auto d-flex flex-column"
        >
          <header>
            <h1>Handleiding Groeimeter Hoe Werkt het?</h1>
            <img src="/assets/images/hoe-werkt-groeimeter-banner.png" />
          </header>
          <section>
            <div class="row">
              <div class="col-12 p-4">
                <p class="mb-4">
                  Je vindt hieronder video's, die je ondersteunen bij het
                  gebruik van Groeimeter. Klik bij elk kopje op de tekst om de
                  video's te bekijken.
                </p>
              </div>
            </div>
          </section>
          <section>
            <div class="row">
              <div class="col-8 px-3 py-4">
                <h2>Hoe kan ik?</h2>
              </div>
              <div class="col-4 p-4">
                <h2>Wat zie ik?</h2>
              </div>
            </div>
          </section>
          <section id="scroll-to-first-time">
            <div class="row">
              <div class="col-8 px-3 py-4">
                <h3>De eerste keer werken met Groeimeter</h3>
                <button
                  type="button"
                  title="bekijk video"
                  data-toggle="modal"
                  data-target="#modal-video-dashboard"
                  class="btn btn-none text-white p-0 m-0 flex-grow-0 flex-shrink-0"
                >
                  <span
                    >Oriënteren: het dashboard in één oogopslag
                    <img class="text-white" src="/assets/icons/video.svg" />
                  </span>
                </button>
                <button
                  type="button"
                  title="bekijk video"
                  data-toggle="modal"
                  data-target="#modal-video-list-goals"
                  class="btn btn-none text-white p-0 m-0 flex-grow-0 flex-shrink-0"
                >
                  <span
                    >Een lijst met alle leerdoelen samenstellen
                    <img
                      class="text-white"
                      src="/assets/icons/video.svg"
                      style="width: 20px; height: 20px"
                  /></span>
                </button>
              </div>
              <div class="col-4 p-4">
                <img
                  data-toggle="modal"
                  data-target="#modal-first-time"
                  [src]="getModals()[0].image"
                  alt="Schermafbeelding 2021-12-07 om 10.29.26.png"
                  fetchpriority="high"
                />
              </div>
            </div>
          </section>
          <section id="scroll-to-filters">
            <div class="row">
              <div class="col-8 px-3 py-4">
                <h3>Het gebruiken van de filters</h3>
                <button
                  type="button"
                  title="bekijk video"
                  data-toggle="modal"
                  data-target="#modal-video-filters"
                  class="btn btn-none text-white p-0 m-0 flex-grow-0 flex-shrink-0"
                >
                  <span
                    >Uitleg over de filtermogelijkheden
                    <img class="text-white" src="/assets/icons/video.svg" />
                  </span>
                </button>
                <button
                  type="button"
                  title="bekijk video"
                  data-toggle="modal"
                  data-target="#modal-video-profile-filters"
                  class="btn btn-none text-white p-0 m-0 flex-grow-0 flex-shrink-0"
                >
                  <span
                    >Profiel toekennen aan een leerling t.b.v. filters
                    <img class="text-white" src="/assets/icons/video.svg" />
                  </span>
                </button>
              </div>
              <div class="col-4 p-4">
                <img
                  data-toggle="modal"
                  data-target="#modal-filters"
                  [src]="getModals()[1].image"
                  fetchpriority="high"
                />
              </div>
            </div>
          </section>
          <section id="scroll-to-plan">
            <div class="row">
              <div class="col-8 px-3 py-4">
                <h3>Plannen van leerdoelen</h3>
                <button
                  type="button"
                  title="bekijk video"
                  data-toggle="modal"
                  data-target="#modal-video-delete-goal"
                  class="btn btn-none text-white p-0 m-0 flex-grow-0 flex-shrink-0"
                >
                  <span
                    >Een gepland leerdoel voor een leerling verwijderen
                    <img class="text-white" src="/assets/icons/video.svg" />
                  </span>
                </button>
                <button
                  type="button"
                  title="bekijk video"
                  data-toggle="modal"
                  data-target="#modal-video-plan-goal-group"
                  class="btn btn-none text-white p-0 m-0 flex-grow-0 flex-shrink-0"
                >
                  <span
                    >Een leerdoel inplannen voor een groep
                    <img class="text-white" src="/assets/icons/video.svg" />
                  </span>
                </button>
                <button
                  type="button"
                  title="bekijk video"
                  data-toggle="modal"
                  data-target="#modal-video-delete-planned-goal"
                  class="btn btn-none text-white p-0 m-0 flex-grow-0 flex-shrink-0"
                >
                  <span
                    >Een gepland leerdoel voor een groep verwijderen
                    <img class="text-white" src="/assets/icons/video.svg"
                  /></span>
                </button>
              </div>
              <div class="col-4 p-4">
                <img
                  data-toggle="modal"
                  data-target="#modal-goals"
                  [src]="getModals()[2].image"
                  fetchpriority="high"
                />
              </div>
            </div>
          </section>
          <section id="scroll-to-student-screen">
            <div class="row">
              <div class="col-8 px-3 py-4">
                <h3>Leerlingscherm</h3>
                <button
                  type="button"
                  title="bekijk video"
                  data-toggle="modal"
                  data-target="#modal-video-login-student"
                  class="btn btn-none text-white p-0 m-0 flex-grow-0 flex-shrink-0"
                >
                  <span
                    >Inloggen en uitloggen van een leerling
                    <img class="text-white" src="/assets/icons/video.svg"
                  /></span></button
                ><button
                  type="button"
                  title="bekijk video"
                  data-toggle="modal"
                  data-target="#modal-video-prepared-test-description"
                  class="btn btn-none text-white p-0 m-0 flex-grow-0 flex-shrink-0"
                >
                  <span
                    >Omschrijving van een toets die klaarstaat bekijken
                    <img class="text-white" src="/assets/icons/video.svg"
                  /></span></button
                ><button
                  type="button"
                  title="bekijk video"
                  data-toggle="modal"
                  data-target="#modal-video-start-test"
                  class="btn btn-none text-white p-0 m-0 flex-grow-0 flex-shrink-0"
                >
                  <span
                    >Een toets starten
                    <img class="text-white" src="/assets/icons/video.svg"
                  /></span></button
                ><button
                  type="button"
                  title="bekijk video"
                  data-toggle="modal"
                  data-target="#modal-video-result-test"
                  class="btn btn-none text-white p-0 m-0 flex-grow-0 flex-shrink-0"
                >
                  <span
                    >Het resultaat van een toets bekijken
                    <img class="text-white" src="/assets/icons/video.svg" />
                  </span>
                </button>
              </div>
              <div class="col-4 p-4">
                <img
                  data-toggle="modal"
                  data-target="#modal-student-screen"
                  [src]="getModals()[3].image"
                  fetchpriority="high"
                />
              </div>
            </div>
          </section>
          <section id="scroll-to-results">
            <div class="row">
              <div class="col-8 px-3 py-4">
                <h3>Bekijken van resultaten</h3>
                <button
                  type="button"
                  title="bekijk video"
                  data-toggle="modal"
                  data-target="#modal-video-student-progress"
                  class="btn btn-none text-white p-0 m-0 flex-grow-0 flex-shrink-0"
                >
                  <span
                    >De voortgang van een leerling bekijken
                    <img class="text-white" src="/assets/icons/video.svg"
                  /></span></button
                ><button
                  type="button"
                  title="bekijk video"
                  data-toggle="modal"
                  data-target="#modal-video-student-goal"
                  class="btn btn-none text-white p-0 m-0 flex-grow-0 flex-shrink-0"
                >
                  <span
                    >Leerdoel van een leerling op gehaald of niet gehaald zetten
                    <img class="text-white" src="/assets/icons/video.svg"
                  /></span></button
                ><button
                  type="button"
                  title="bekijk video"
                  data-toggle="modal"
                  data-target="#modal-video-student-goal-replan"
                  class="btn btn-none text-white p-0 m-0 flex-grow-0 flex-shrink-0"
                >
                  <span
                    >Een leerdoel van een leerling opnieuw inplannen
                    <img class="text-white" src="/assets/icons/video.svg" />
                  </span>
                </button>
              </div>
              <div class="col-4 p-4">
                <img
                  data-toggle="modal"
                  data-target="#modal-results"
                  [src]="getModals()[4].image"
                  fetchpriority="high"
                />
              </div>
            </div>
          </section>
          <section id="scroll-to-profiles">
            <div class="row">
              <div class="col-8 px-3 py-4">
                <h3>Werken met profielen</h3>
                <button
                  type="button"
                  title="bekijk video"
                  data-toggle="modal"
                  data-target="#modal-video-profile-spelling"
                  class="btn btn-none text-white p-0 m-0 flex-grow-0 flex-shrink-0"
                >
                  <span
                    >Werken met profielen: Spelling
                    <img class="text-white" src="/assets/icons/video.svg" />
                  </span></button
                ><button
                  type="button"
                  title="bekijk video"
                  data-toggle="modal"
                  data-target="#modal-video-profile-math"
                  class="btn btn-none text-white p-0 m-0 flex-grow-0 flex-shrink-0"
                >
                  <span
                    >Werken met profielen: Rekenen
                    <img class="text-white" src="/assets/icons/video.svg" />
                  </span>
                </button>
              </div>
              <div class="col-4 p-4">
                <img
                  data-toggle="modal"
                  data-target="#modal-profile"
                  [src]="getModals()[5].image"
                  fetchpriority="high"
                />
              </div>
            </div>
          </section>
          <section id="scroll-to-create-learn-line">
            <div class="row">
              <div class="col-8 px-3 py-4">
                <h3>Eigen leerlijn samenstellen</h3>
                <button
                  type="button"
                  title="bekijk video"
                  data-toggle="modal"
                  data-target="#modal-video-learn-line-selection"
                  class="btn btn-none text-white p-0 m-0 flex-grow-0 flex-shrink-0"
                >
                  <span
                    >Een leerlijn met een selectie van leerdoelen maken
                    <img class="text-white" src="/assets/icons/video.svg"
                  /></span></button
                ><button
                  type="button"
                  title="bekijk video"
                  data-toggle="modal"
                  data-target="#modal-video-learn-line-add-remove-goal"
                  class="btn btn-none text-white p-0 m-0 flex-grow-0 flex-shrink-0"
                >
                  <span
                    >Een leerdoel aan een leerlijn toevoegen of verwijderen
                    <img class="text-white" src="/assets/icons/video.svg" />
                  </span></button
                ><button
                  type="button"
                  title="bekijk video"
                  data-toggle="modal"
                  data-target="#modal-video-learn-line-save"
                  class="btn btn-none text-white p-0 m-0 flex-grow-0 flex-shrink-0"
                >
                  <span
                    >Voorbeeld van een leerdoel in de leerlijn bekijken
                    <img class="text-white" src="/assets/icons/video.svg"
                  /></span></button
                ><button
                  type="button"
                  title="bekijk video"
                  data-toggle="modal"
                  data-target="#modal-video-learn-line-delete"
                  class="btn btn-none text-white p-0 m-0 flex-grow-0 flex-shrink-0"
                >
                  <span
                    >Een leerlijn verwijderen
                    <img class="text-white" src="/assets/icons/video.svg" />
                  </span>
                </button>
              </div>
              <div class="col-4 p-4">
                <img
                  data-toggle="modal"
                  data-target="#modal-learn-line"
                  [src]="getModals()[6].image"
                  fetchpriority="high"
                />
              </div>
            </div>
          </section>
        </div>

        <div
          *ngIf="showFaq"
          style="max-width: 980px"
          class="application-info__container__content mx-auto d-flex flex-column"
        >
          <section>
            <div class="row">
              <div class="col-12 p-4">
                <h1>Veelgestelde vragen</h1>
              </div>
            </div>
          </section>
          <section id="scroll-to-faq-learn-goals">
            <div class="row">
              <div class="col-12 p-4">
                <h3>Waar komen de leerdoelen vandaan?</h3>
                <p>
                  De leerdoelen in Groeimeter zijn gebaseerd op de leerdoelen
                  van het SLO. Deze hebben we voor de leerlingen in de
                  leerlingomgeving herschreven.
                </p>
              </div>
            </div>
          </section>
          <section id="scroll-to-faq-white-screen">
            <div class="row">
              <div class="col-12 p-4">
                <h3>Na het inloggen kom ik in een wit scherm, hoe kan dit?</h3>
                <p>
                  Zie je na inloggen alleen een wit scherm? Dan zijn er geen
                  groepen aan jou gekoppeld in Basispoort. Dit komt voor als je
                  intern begeleider of ICT-coördinator bent. Groeimeter werkt
                  alleen als je gekoppelde groepen hebt.
                </p>
              </div>
            </div>
          </section>
          <section id="scroll-to-faq-change-image">
            <div class="row">
              <div class="col-12 p-4">
                <h3>Kan ik een leerling een ander plaatje geven?</h3>
                <p>
                  De plaatjes worden automatisch toegekend aan een leerling en
                  kunnen niet gewijzigd worden. Wanneer er een nieuwe leerling
                  bij komt, verschijnt er een nieuw plaatje.
                </p>
              </div>
            </div>
          </section>
          <section id="scroll-to-faq-abort-test">
            <div class="row">
              <div class="col-12 p-4">
                <h3>
                  Wat gebeurt er als een leerling het toetsje afbreekt tijdens
                  het invullen?
                </h3>
                <p>
                  Wanneer de leerling tussentijds stopt met het invullen van een
                  toetsje, onthoud Groeimeter waar hij/zij gebleven is. Zo kan
                  de leerling de volgende keer weer verder waar hij/zij was.
                </p>
              </div>
            </div>
          </section>
          <section id="scroll-to-faq-slo">
            <div class="row">
              <div class="col-12 p-4">
                <h3>Voldoet Groeimeter aan alle kerndoelen van SLO?</h3>
                <p>
                  Groeimeter is gebaseerd op de leerdoelenset Rekenen van SLO.
                  Als je al deze leerdoelen behandelt, werk je automatisch toe
                  naar de kerndoelen en dus de referentieniveaus.
                </p>
              </div>
            </div>
          </section>
          <section id="scroll-to-faq-add-goals">
            <div class="row">
              <div class="col-12 p-4">
                <h3>Kan ik zelf leerdoelen toevoegen?</h3>
                <p>Ja, het is ook mogelijk om zelf leerdoelen toe te voegen.</p>
              </div>
            </div>
          </section>
          <section id="scroll-to-faq-lvs">
            <div class="row">
              <div class="col-12 p-4">
                <h3>
                  Hoe gebruik ik Groeimeter in combinatie met LVS-afnames?
                </h3>
                <p>Groeimeter en de LVS-afnames vullen elkaar prima aan.</p>
                <ul>
                  <li>
                    Wil je bijvoorbeeld in aanloop naar een LVS-afname zicht
                    krijgen op waar je leerlingen staan? Gebruik Groeimeter dan
                    in de periode voorafgaand aan een LVS-afname. De leerlingen
                    kunnen zich dan goed op de afname voorbereiden.
                  </li>
                  <li>
                    Wil je juist na een LVS-afname met je leerlingen aan de
                    slag? Ook dan kun je van Groeimeter gebruikmaken. De
                    leerlingen kunnen zich dan bijvoorbeeld richten op de
                    leerdoelen die ze nog lastig vinden.
                  </li>
                </ul>
              </div>
            </div>
          </section>
          <section id="scroll-to-faq-lvs-groeimeter">
            <div class="row">
              <div class="col-12 p-4">
                <h3>
                  Wat is het verschil tussen het meten van beheersing
                  (Groeimeter) en van vaardigheid (LVS-toetsen)?
                </h3>
                <p>
                  Toetsen bij Groeimeter zijn bedoeld om na te gaan of een
                  leerling de leerdoelen voldoende beheerst. Hierdoor zijn ze zo
                  gemaakt dat de meeste leerlingen vrijwel alles goed kunnen. De
                  leerkracht weet zo of hij door kan gaan naar het volgende
                  leerdoel of dat herhaling van het leerdoel wenselijk is.
                </p>
                <p>
                  De LVS-toetsen hebben een ander doel. Ze zijn bedoeld om het
                  vaardigheidsniveau van leerlingen te kunnen vergelijken met
                  het niveau van klasgenoten. Daarom bevatten de toetsen niet
                  alleen opgaven van lesstof die zojuist is behandeld, maar ook
                  oude en zelfs toekomstige lesstof. Door opgaven van oude
                  lesstof op te nemen, kan nagegaan worden of leerlingen die
                  oude stof nog wel kennen. En door ook moeilijkere opgaven in
                  de toets op te nemen, kunnen de betere leerlingen laten zien
                  wat ze nog méér kunnen. Bovendien kunnen met de toetsen van
                  Cito de ontwikkeling van leerlingen gedurende de basisschool
                  worden gevolgd.
                </p>
              </div>
            </div>
          </section>
          <section id="scroll-to-faq-use-cases">
            <div class="row">
              <div class="col-12 p-4">
                <h3>Op welke manieren kan ik Groeimeter inzetten?</h3>
                <p>Je kan Groeimeter inzetten zoals jij dat wil:</p>
                <ul>
                  <li>
                    Wil je leerlingen met een eigen leerlijn op leerdoelniveau
                    volgen? Dat kan. Je gebruikt de module Groeimeter om één of
                    meerdere leerdoelen klaar te zetten, waarvan jij denkt dat
                    een leerling die op dat moment aan kan. Je bepaalt zelf
                    wanneer je voor welke leerling welk(e) leerdoel(en) wil
                    klaar zetten.
                  </li>
                  <li>
                    <p>
                      Wil je dat het LVS je helpt om tot op leerdoelniveau
                      inzicht te krijgen, waar je met een leerling na een LVS-
                      afname mee aan de slag kunt? Dat kan ook. De LVS-analyses
                      geven je tot op domeinniveau (getallen, verhoudingen,
                      etc.) zicht op wat er goed en minder goed gaat.
                    </p>
                    <p>
                      Selecteer bijvoorbeeld voor leerlingen die op- of
                      uitvallen in de leerdoelenmodule het niveau (M6) en het
                      domein (getallen) waarvoor je meer inzicht wil, en krijg
                      zo zicht tot op leerdoelniveau waar je met de leerling de
                      komende periode aan de slag kunt.
                    </p>
                  </li>
                </ul>
              </div>
            </div>
          </section>
          <section id="scroll-to-faq-math-spelling">
            <div class="row">
              <div class="col-12 p-4">
                <h3>Is Groeimeter een reken- of een spellingmethode?</h3>
                <p>
                  Groeimeter is geen reken- of spellingmethode en bevat geen
                  koppeling naar lesmateriaal. Je kan Groeimeter wel aanvullend
                  op je reken- en spellingmethode inzetten. Werk je zonder
                  methode? Dan kun je Groeimeter gebruiken om grip op leerdoelen
                  te krijgen. Je maakt bijvoorbeeld een eigen leerlijn met
                  leerdoelen per jaargroep aan. Met de informatie uit Groeimeter
                  stel je daarna je lesaanbod optimaal samen.
                </p>
              </div>
            </div>
          </section>
          <section id="scroll-to-faq-select-goals">
            <div class="row">
              <div class="col-12 p-4">
                <h3>Kan ik in Groeimeter leerdoelen selecteren?</h3>
                <p>
                  Het is heel eenvoudig om in Groeimeter leerdoelen te
                  selecteren. Dit kan:
                </p>
                <ul>
                  <li>Per leerling</li>
                  <li>Voor je hele groep</li>
                  <li>
                    Voor een deel van de groep, bijvoorbeeld voor alle
                    leerlingen die op weg zijn naar 1F.
                  </li>
                </ul>
                <p>
                  Je kunt hierbij ook leerdoelen uit verschillende jaargroepen
                  selecteren, precies wat aansluit bij elke leerling.
                </p>
              </div>
            </div>
          </section>
          <section id="scroll-to-faq-webbased">
            <div class="row">
              <div class="col-12 p-4">
                <h3>Is Groeimeter webbased?</h3>
                <p>
                  Ja, Groeimeter is webbased en te gebruiken op verschillende
                  apparaten, zoals een laptop en een Chromebook. De toetsjes in
                  Groeimeter Rekenen zijn af te nemen op iPad. Binnenkort is dat
                  ook het geval voor de toetsjes in Groeimeter Spelling.
                </p>
              </div>
            </div>
          </section>
          <section>
            <div class="row">
              <div class="col-12 p-4">
                <p>
                  Staat je vraag er niet tussen?
                  <a href="https://cito.nl/contact">Laat het ons weten</a>!
                </p>
              </div>
            </div>
          </section>
        </div>
      </div>

      <div class="d-none col-lg-3"></div>
    </div>
  </div>

  <!-- MODALS -->

  <div
    *ngFor="let modal of getModals()"
    class="modal fade"
    [id]="modal.id"
    tabindex="-1"
    aria-labelledby="modalFirstTime"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-xl modal-dialog-centered">
      <div class="modal-content" style="z-index: 1100">
        <div class="modal-header">
          <h5 class="modal-title">{{ modal.title }}</h5>
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body d-flex justify-content-center">
          <img [src]="modal.image" alt="" fetchpriority="high" class="w-full" />
        </div>
      </div>
    </div>
  </div>

  <div
    *ngFor="let modal of getVideoModals()"
    class="modal fade"
    [id]="modal.id"
    tabindex="-1"
    aria-labelledby="modalFirstTime"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-xl modal-dialog-centered">
      <div class="modal-content" style="z-index: 1100">
        <div class="modal-header">
          <h5 class="modal-title">{{ modal.title }}</h5>
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body d-flex justify-content-center">
          <video
            [id]="'modal-video-' + modal.id"
            [src]="'/assets/videos/' + modal.video"
            controls
            alt=""
            fetchpriority="high"
          ></video>
        </div>
      </div>
    </div>
  </div>
</div>
